import { Block, Button, Text } from '@mote/ui'
import { GenericRecorderErrorsTemplate } from './GenericRecorderErrorsTemplate'

export const ForceUpgradeError = ({ onClose }) => {
  function handleLearnMore() {
    window.open(
      'https://support.mote.com/hc/en-us/articles/4411832864404',
      '_blank'
    )
  }

  return (
    <GenericRecorderErrorsTemplate
      onClose={onClose}
      header='⌛️ Extension Outdated'
      content={
        <Block gap={16}>
          <Text fontWeight={400} fontSize={15} color='grey.d2'>
            It looks like you are using an old and unsupported version of Mote
            extension. Please update your extension in order to record a mote.
          </Text>
        </Block>
      }
      buttons={
        <>
          <Button
            variant='secondary'
            text='Dismiss'
            onClick={() => onClose()}
            autoWidth
          />
          <Button
            variant='primary'
            text='Learn more'
            onClick={handleLearnMore}
            autoWidth
          />
        </>
      }
    />
  )
}
